import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import {Chart} from 'angular-highcharts';
import * as fromProfile from '../../store/profile.reducers';
import {Observable, Subscription} from 'rxjs';
import * as ProfileActions from '../../store/profile.actions';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {ChartService} from '../../chart.service';
import {Profile} from '../../profile.model';
import * as DemoActions from '../../../demo/store/demo.actions';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-profile-analyze',
    templateUrl: './profile-analyze.component.html',
    styleUrls: ['./profile-analyze.component.scss'],
    standalone: false
})
export class ProfileAnalyzeComponent implements OnInit, OnDestroy {

  readonly auditType = input<'profile' | 'demo'>(undefined);
  @Input() id: number;
  code: string;
  typeMedia: number;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsMediaAnalyze: Chart[];
  audit: Profile;
  timezone: string;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService

  ) { }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnInit() {
    const offsetTimezone = new Date().getTimezoneOffset() / 60;
    this.timezone = offsetTimezone.toString();
    if (offsetTimezone > 0) {
      this.timezone = '+' + offsetTimezone.toString();
    }

    this.typeMedia = 1;
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
        if (this.id !== undefined && this.auditType() === 'profile') {
          this.store.dispatch(
            new ProfileActions.GetMediaAnalyze({
              id: +this.id,
              type: this.typeMedia,
              params: {
                code: this.code
              }
            })
          );
        }

      }
    );
    this.profileSubscription = this.store.select(this.getAuditType()).subscribe(
      (state: fromProfile.State) => {
        this.audit = state.audit;
        if (state.mediaAnalyze !== null && (state.chartReload === this.getAuditActions().SET_MEDIA_ANALYZE || this.auditType() === 'demo')) {
          this.chartsMediaAnalyze = [];
          this.chartsMediaAnalyze.push(
            ChartService.getLikeByDayChart(state.mediaAnalyze.day),
            ChartService.getCommentByDayChart(state.mediaAnalyze.day),
            ChartService.getMediaByDayChart(state.mediaAnalyze.day),
            ChartService.getMediaByHourSumChart(state.mediaAnalyze.hour_sum),
            ChartService.getMediaByWeekDayChart(state.mediaAnalyze.week_day),
            ChartService.getMediaHashtagChart(state.mediaAnalyze.hashtag_rank),
            ChartService.getMediaTagChart(state.mediaAnalyze.tag_rank)
          );
        }

      }
    );
  }

  setTypeMedia(type: number) {
    if (this.id !== undefined && this.audit !== null && this.audit.status !== 0) {
      this.typeMedia = type;
      this.store.dispatch(
        new ProfileActions.GetMediaAnalyze({
          id: +this.id,
          type: type,
          params: {
            code: this.code
          }
        })
      );
    } else if (this.audit !== null && this.audit.status === 0) {
      this.notifierService.warning('No access in trial account');
    } else {
      this.notifierService.info('No access in demo audit');
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
